<template>
  <div class="connexion">
    <section class="panneau-marque" aria-hidden="true">
      <div class="marque"><img src="/favicon.svg" alt="" width="40" height="40" /> Boutique Pro</div>
      <div class="ticket-deco">
        <div class="td-ligne"><span>Riz parfumé 25 kg</span><span>17 500</span></div>
        <div class="td-ligne"><span>Huile 5 L × 2</span><span>12 000</span></div>
        <div class="td-ligne"><span>Sucre 1 kg × 3</span><span>2 100</span></div>
        <div class="td-total"><span>Total</span><span>31 600 F</span></div>
      </div>
      <p class="accroche">La caisse, le stock et les comptes de vos boutiques, au même endroit.</p>
    </section>

    <section class="panneau-form">
      <form class="carte" @submit.prevent="login" novalidate>
        <h1>{{ nomEntreprise || 'Connexion' }}</h1>
        <p class="text-muted mb-4">Connectez-vous pour ouvrir votre caisse.</p>
        <div v-if="globalError" class="alert alert-danger py-2" role="alert">{{ globalError }}</div>
        <label class="form-label" for="email">E-mail</label>
        <input id="email" v-model.trim="email" type="email" class="form-control form-control-lg mb-1" :class="{ 'is-invalid': error.email }" autocomplete="username" autofocus />
        <div class="invalid-feedback d-block mb-2">{{ error.email }}</div>
        <label class="form-label" for="mdp">Mot de passe</label>
        <div class="input-group mb-1">
          <input id="mdp" v-model="password" :type="voir ? 'text' : 'password'" class="form-control form-control-lg" :class="{ 'is-invalid': error.password }" autocomplete="current-password" />
          <button type="button" class="btn btn-light border" @click="voir = !voir" :aria-label="voir ? 'Masquer le mot de passe' : 'Afficher le mot de passe'"><i class="bi" :class="voir ? 'bi-eye-slash' : 'bi-eye'"></i></button>
        </div>
        <div class="invalid-feedback d-block mb-2">{{ error.password }}</div>
        <button class="btn btn-safran btn-lg w-100 mt-2" :disabled="isLoading"><span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>Se connecter</button>
        <div class="text-center mt-3"><router-link to="/mot-de-passe-oublie" class="small">Mot de passe oublié ?</router-link></div>
        <div class="text-center mt-2 small text-muted">Pas encore de compte ? <router-link to="/inscription">Essai gratuit</router-link></div>
        <div class="mt-3"><InstallerApplication variante="carte" /></div>
      </form>
    </section>
  </div>
</template>

<script>
import api from "@/api";
import InstallerApplication from "@/components/commun/InstallerApplication.vue";

export default {
  name: "LoginPage",
  components: { InstallerApplication },
  data: () => ({ email: "", password: "", voir: false, isLoading: false, globalError: "", error: { email: "", password: "" }, nomEntreprise: "" }),
  async mounted() {
    this.globalError = this.$route.query.message || "";
    try {
      const { data } = await api.get("configurations/entete");
      this.nomEntreprise = data?.nom || "";
    } catch (e) { /* écran de connexion générique */ }
  },
  watch: { "$route.query.message"(m) { this.globalError = m || ""; } },
  methods: {
    validate() {
      this.globalError = "";
      this.error = { email: "", password: "" };
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) this.error.email = "Saisissez une adresse e-mail valide.";
      if (!this.password) this.error.password = "Saisissez votre mot de passe.";
      return !this.error.email && !this.error.password;
    },
    async login() {
      if (!this.validate() || this.isLoading) return;
      this.isLoading = true;
      try {
        const r = await this.$store.dispatch("authenticate", { email: this.email, password: this.password });
        if (r.success) this.$router.push(this.$route.query.suite || "/");
        else this.globalError = r.message || "E-mail ou mot de passe incorrect.";
      } catch (e) {
        this.globalError = "Le serveur ne répond pas. Vérifiez votre connexion.";
      } finally {
        this.password = "";
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.connexion { min-height: 100vh; display: grid; grid-template-columns: 1.1fr 1fr; }
.panneau-marque { background: var(--indigo-900); color: #fff; padding: 40px 56px; display: flex; flex-direction: column; justify-content: space-between; }
.marque { display: flex; align-items: center; gap: 12px; font-weight: 700; font-size: 1.2rem; }
.ticket-deco { align-self: center; width: 290px; background: #fff; color: var(--encre); padding: 22px 22px 26px; font-family: "Courier New", monospace; transform: rotate(-3deg); box-shadow: 0 30px 60px rgba(0,0,0,.35);
  -webkit-mask: radial-gradient(circle 7px at 50% 100%, transparent 98%, #000) 0 0 / 18px 100% repeat-x; mask: radial-gradient(circle 7px at 50% 100%, transparent 98%, #000) 0 0 / 18px 100% repeat-x; }
.td-ligne, .td-total { display: flex; justify-content: space-between; padding: 4px 0; font-size: .92rem; }
.td-total { border-top: 1px dashed #000; margin-top: 8px; padding-top: 10px; font-weight: 700; font-size: 1.15rem; }
.accroche { font-family: var(--police-chiffres); font-size: 1.9rem; font-weight: 700; line-height: 1.15; max-width: 460px; color: #fff; margin: 0; }
.panneau-form { display: flex; align-items: center; justify-content: center; padding: 32px 20px; background: var(--fond); }
.carte { width: 100%; max-width: 400px; }
.carte h1 { font-size: 1.7rem; margin-bottom: 4px; }
@media (max-width: 900px) {
  .connexion { grid-template-columns: 1fr; }
  .panneau-marque { padding: 24px; }
  .ticket-deco, .accroche { display: none; }
}
</style>
